import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  private sessionStorage;
  private isMock = false;


  constructor() {
    if (typeof(Storage) !== 'undefined') {
      this.sessionStorage = sessionStorage;
    } else {
      this.isMock = true;
      this.sessionStorage = new Map<string, any>();
      console.warn('session storage is not running use mock sessionstorage instead !!!');
    }
  }

  /**
   * Get Item
   *
   * @param key
   */
  getItem(key: string) {

    const rawData = this.isMock ? this.sessionStorage.get(key) : this.sessionStorage.getItem(key);

    return (rawData !== undefined) ? rawData : null;

  }

  /**
   * Sets an item in session storage
   * @param key The item's key
   * @param data The item's value, must NOT be null or undefined
   * @returns {boolean}
   */
  setItem(key: string, data: any) {
    if (this.isMock) {
      this.sessionStorage.set(key, data);
    } else {
      this.sessionStorage.setItem(key, data);
    }

    return true;

  }

  /**
   * Deletes an item in session storage
   * @param key The item's key
   * @returns {boolean}
   */
  removeItem(key: string) {
    if (this.isMock) {
      this.sessionStorage.delete(key);
    } else {
      this.sessionStorage.removeItem(key);
    }

    return true;

  }

  /**
   * Deletes all items from session storage
   * @returns {boolean}
   */
  clear() {

    this.sessionStorage.clear();

    return true;

  }
}
